export const addHeadingMarginInline = (html: string): string => {
  // Xử lý heading h1 - h6
  html = html.replace(/<h([1-6])(.*?)>/g, (_match, level, attrs) => {
    const hasStyle = /style=/.test(attrs)
    if (hasStyle) {
      return `<h${level}${attrs.replace(/style="([^"]*)"/, 'style="$1;margin:0;"')}>`
    } else {
      return `<h${level}${attrs} style="margin:0;">`
    }
  })

  html = html.replace(/<ul(.*?)>/g, (_match, attrs) => {
    const hasStyle = /style=/.test(attrs)
    if (hasStyle) {
      return `<ul${attrs.replace(/style="([^"]*)"/, 'style="$1;margin:0;padding-left:20px;"')}>`
    } else {
      return `<ul${attrs} style="margin:0;padding-left:20px;">`
    }
  })
  html = html.replace(/<li(.*?)>/g, (_match, attrs) => {
    const hasStyle = /style=/.test(attrs)
    if (hasStyle) {
      return `<li${attrs.replace(/style="([^"]*)"/, 'style="$1;padding-left:20px;"')}>`
    } else {
      return `<li${attrs} style="padding-left:20px;">`
    }
  })

  html = html.replace(
    /(<[^>]*class="[^"]*\bql-indent-(\d+)\b[^"]*"[^>]*)(>)/g,
    (_match, prefix, level, suffix) => {
      const indentPx = parseInt(level) * 48
      if (/style="/.test(prefix)) {
        return (
          prefix.replace(
            /style="([^"]*)"/,
            `style="$1;margin-left: ${indentPx}px;"`
          ) + suffix
        )
      } else {
        return `${prefix} style="margin-left: ${indentPx}px;"${suffix}`
      }
    }
  )

  return html
}
